// Design System showcase — mirrors sf-react-app views/app/design-system (sections added step by step)
import React from 'react';
import { Spacer } from 'design-system';
import '../../../design-system/foundations/variables.scss';
import PaletteShowcase from './PaletteShowcase';
import TypographyShowcase from './TypographyShowcase';
import ButtonShowcase from './ButtonShowcase';
import IconsShowcase from './IconsShowcase';
import BadgeShowcase from './BadgeShowcase';
import InputShowcase from './InputShowcase';
import GridsAndLayoutsShowcase from './GridsAndLayoutsShowcase';
import DropdownShowcase from './DropdownShowcase';
import HeaderShowcase from './HeaderShowcase';
import TabsShowcase from './TabsShowcase';
import ModalShowcase from './ModalShowcase';
import AccordionShowcase from './AccordionShowcase';
import FeedShowcase from './FeedShowcase';
import './styles.css';

const DesignSystemShowcase = () => {
  return (
    <div className="ds-showcase-page">
      <PaletteShowcase />
      <Spacer size={6} />
      <TypographyShowcase />
      <Spacer size={6} />
      <ButtonShowcase />
      <Spacer size={6} />
      <IconsShowcase />
      <Spacer size={6} />
      <BadgeShowcase />
      <Spacer size={6} />
      <InputShowcase />
      <Spacer size={6} />
      <DropdownShowcase />
      <Spacer size={6} />
      <GridsAndLayoutsShowcase />
      <Spacer size={6} />
      <HeaderShowcase />
      <Spacer size={6} />
      <TabsShowcase />
      <Spacer size={6} />
      <ModalShowcase />
      <Spacer size={6} />
      <AccordionShowcase />
      <Spacer size={6} />
      <FeedShowcase />
    </div>
  );
};

export default DesignSystemShowcase;
